export const buttonStyle = {
  width: '14px',
  height: '14px',
  color: '#777777',
  cursor: 'pointer',
}